<template>
  <v-app id="inspire">
    <router-view/>
  </v-app>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue